import * as React from 'react';
import withStyles from 'react-jss';
import { CssType } from '../theme/jss-types';
import { Menu } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

const styles = (): CssType => ({
  drawer: {
    '& .ant-drawer-body': {
      padding: '0px !important',
      '&>.ant-menu': {
        height: 'auto !important',
        minHeight: '100vh !important',
      },
    },
  },
  menuItem: {},
  alertsMenuMobile: {
    display: 'none',
  },
  // [`@media (max-width: ${MOBILE_BREAK_POINT}px)`]: {
  //   hideLayout: {
  //     display: 'none',
  //   },
  //   alertsMenuDesktop: {
  //     display: 'none',
  //   },
  //   alertsMenuMobile: {
  //     display: 'initial',
  //   },
  // },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    height: '60px !important',
    '&:hover': {
      cursor: 'unset',
    },
  },
  userContainer: {
    display: 'flex',
    alignItems: 'center',
    height: '60px !important',
    '&:hover': {
      cursor: 'unset',
    },
    justifyContent: 'space-between',
    borderTop: '1px solid #ccc',
  },
  userTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    '&:hover': {
      cursor: 'unset',
    },
  },
  userName: {
    height: '50%',
  },
  changePassword: {
    height: '50%',
    cursor: 'pointer',
    color: '#0780FE !important',
    fontSize: '12px',
  },
  switchToV1: {
    cursor: 'pointer',
    color: '#0780FE',
    fontSize: '12px',
  },
});
const SideMenu = (props: any) => {
  const {
    openKeys,
  } = props;

  return (
    <div>
      <Menu
        mode="inline"
        openKeys={openKeys}
        // onOpenChange={onOpenChange}
        style={{ width: 256, height: '100%' }}
        selectable={false}
        theme="light"
      />
    </div>
  );
};

const mapStateToProps = (state: any) => {
  const { masterData, navigation } = state;
  return {
    masterData,
    navigation,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({}, dispatch);
};

const SideMenuV2Styled = withStyles(styles, { injectTheme: true })(SideMenu);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SideMenuV2Styled),
) as any;
